import { useGetQuery } from "hooks/queries"
import { SigmaSolution } from "../types"

export function useFetchSigmaSolutions(accountAlias: string): { solutions: SigmaSolution[], isPending: boolean, isError: boolean, error: Error | null } {
  const { data, isPending, isError, error } = useGetQuery<{ solutions: SigmaSolution[] }>({
    url: `/api/${accountAlias}/solutions/sigma`,
  })
  return { solutions: data?.solutions ?? [], isPending, isError, error }
}
